export default {
    namespaced: true,
    state: {
      recipient: {}
    },
    getters: {
      recipient: state => state.recipient
    },
    actions: {
      resetCurrent: (context) => {
        context.commit('resetCurrent');
      },
      setRecipient: (context, recipient) => {
        context.commit("setRecipient", recipient);
      }            
    },
    mutations: {
      resetCurrent: (state) => {
        state.recipient = {};
      },
      setRecipient: (state, recipient) => {
        state.recipient = { ...recipient }; //make a "deep" copy
      }      
    }
  }
  